export default "skymp5-front/c47a07801fbff755432faab70c63dd1c.gif";